import * as actionTypes from "../actions/actionTypes";

const initialState = {
  writings: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_WRITINGS:
      console.log("set writings reducer", action);
      const { payload } = action;
      return {
        ...state,
        writings: payload,
      };
    default:
      return state;
  }
};

export default reducer;
